import React, { PureComponent } from 'react'
import T from 'prop-types'
import _ from 'lodash'
import IT from 'react-immutable-proptypes'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  DataTable,
  CircleLoader
  // Button
} from 'react-base'
import {
  is,
  Map,
  List,
  Set,
  OrderedMap
} from 'immutable'
import {
  pluralize
} from 'pw-formatters'
import {
  FIELD_OPTIONS_SHAPE,
  CUSTOM_INPUTS_SHAPE,
  COLUMN_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'
import Grid from './Grid'
// import Inputs from '../form/Inputs'
import memoize from 'memoize-one'

const SAVE_SUCCESS_MSG_TIMEOUT = 5000 // ms that "save success" message is displayed

const COLUMN_PREFS_SHAPE = IT.listOf(IT.mapContains({
  key: T.string.isRequired,
  width: T.oneOfType([T.number, T.func]),
  height: T.oneOfType([T.number, T.func]),
  columns: IT.listOf(IT.mapContains({
    key: T.string.isRequired,
    width: T.oneOfType([T.number, T.func]),
    height: T.oneOfType([T.number, T.func]),
    columns: IT.listOf(IT.mapContains({
      key: T.string.isRequired,
      width: T.oneOfType([T.number, T.func]),
      height: T.oneOfType([T.number, T.func])
    }))
  }))
}))

const defaultRowKeyFn = (rowKey, row) => row.get('id', rowKey)

export default class Table extends PureComponent {
  static displayName = 'Schemer.Table'

  static propTypes = {
    className: T.string,
    error: T.any,

    isLoading: T.bool,
    isSaving: T.bool,
    readOnly: T.bool,

    schema: SCHEMA_SHAPE.isRequired,
    values: IT.list, // TODO formal definition?
    // currentValues: IT.map,
    validate: T.func, // If passed, will be passed whole formValue after each valid input change. If a string is returned the form is considered invalid

    onSave: T.func,
    onSaveArgs: IT.list,
    onCancel: T.func,
    onReset: T.func,
    onPrefsChanged: T.func, // If supplied, will be called with all internal preference changes (column order/sizing)
    onSortChanged: T.func,

    // customInputs is a map of schema fieldName keys to React components
    customInputs: CUSTOM_INPUTS_SHAPE,
    fieldOptions: FIELD_OPTIONS_SHAPE,

    // initialColumnOrder: IT.listOf(T.string),

    columnPrefs: COLUMN_PREFS_SHAPE,

    clientSort: T.bool, // If true, this component will sort the data provided
    getRowKey: T.func,

    columnHeaderComponent: T.oneOfType([T.element, T.func]), // React Component or Functional/Stateless component
    columnHeaderComponentProps: IT.mapOf(T.any, T.string),
    rowHeaderComponent: T.oneOfType([T.element, T.func]), // React Component or Functional/Stateless component
    rowHeaderComponentProps: IT.mapOf(T.any, T.string),

    renderRowHeader: T.bool
  }

  static defaultProps = {
    fieldOptions: Map(),
    customInputs: Map(),
    renderRowHeader: false,
    getRowKey: defaultRowKeyFn,
    columnPrefs: null
  }

  constructor(props) {
    super(props)

    this.state = {
      // columns: Map(),
      pendingValues: List(), // Pending changes
      // mergedValues: this._getSortedMergedValues(props, defaultPartialState), // Current state of data, including existing and pending values merged
      sortColumn: "",
      sortDescending: false,
      // columnPrefs: props.initialColumnPrefs || List(), // List (ordered) of {key: <column key>, width: <column width> }
      stickyColKeys: Set(),
      stickyRowKeys: Set()
      // columnOrder: null,
      // columnSizes: Map() // Initial column sizes may be specified in the Schema under `table.column.width`
      // formInvalid: null,
      // invalidMessages: Map(), // Matches shape of pendingValues
      // saveSuccess: false,
      // showAllValidationErrors: false,
      // errorSuppressed: false
    }

    // if (props.schema) {
    //   this.state.columns = props.schema.getDataTableColumns()
    //   // if (this.state.columnPrefs.size === 0) {
    //   //   this.state.columnPrefs = props.schema.getDefaultColumnPrefs()
    //   // }
    // }
    // console.log('initial col prefs', this.state.columnPrefs)

  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.schema !== this.props.schema) {
  //     console.log('COLUMNS changed')

  //     this.setState({
  //       columns: nextProps.schema.getDataTableColumns(),
  //       // columnPrefs: nextProps.schema.getDefaultColumnPrefs()
  //     })
  //   }
  //   if (nextProps.initialColumnPrefs !== this.props.initialColumnPrefs) {
  //     // this.setState({
  //     //   columnPrefs: nextProps.initialColumnPrefs
  //     // })
  //   }
  // }

  _handleColumnPrefsChange = newColumnPrefs => {
    const {
      onPrefsChanged
    } = this.props
    this.setState({
      columnPrefs: newColumnPrefs
    })
    if (onPrefsChanged) {
      onPrefsChanged(newColumnPrefs)
    }
  }

  handleRequestNextPage = () => {
    // TODO
  }

  handleColumnSortChange = (colDef, ascOrDesc) => {
    const {
      onSortChanged
    } = this.props

    const sortColumn = colDef.key
    const sortDescending = ascOrDesc === 'desc'

    this.setState({
      sortColumn,
      sortDescending
    })

    if (onSortChanged) {
      onSortChanged(sortColumn, sortDescending)
    }
  }

  handleColumnResize = (colDef, width) => {
    // console.log('resize?', colDef, width)
    this._handleColumnPrefsChange(this.state.columnPrefs.set(colDef.key, width))
  }

  handleColumnReorder = newOrder => {
    // console.log('handleColumnReorder', newOrder)
    this._handleColumnPrefsChange(this.state.columnPrefs.sort((width, columnKey) => newOrder.indexOf(columnKey)) )
  }

  handleColumnOrderReset = () => {
    // AuditLogActions.resetColumnOrder()
  }

  // getMergedColumns = (columnPrefs, columns) => {
  //   if (columnPrefs && columnPrefs.size && columnPrefs.size > 0) {
  //     return columnPrefs.map(colPref => {
  //       const col = columns.get(colPref.get('key'), {})
  //       let out = col.merge(colPref)
  //       const nestedColumnPrefs = colPref.get('columns')
  //       if (nestedColumnPrefs) {
  //         out = out.set('columns', this.getMergedColumns(nestedColumnPrefs, col.get('columns')))
  //       }
  //       return out
  //     })
  //   }
  //   else {
  //     return columns
  //   }
  // }

  _getKeyedMergedSortedRows = memoize((values, pendingValues, getRowKey, clientSort, sortColumn, sortDescending) => {
    let currentValues = values && values.toKeyedSeq().mapKeys(getRowKey).toOrderedMap()

    currentValues = currentValues.mergeDeep(pendingValues)

    if (clientSort && currentValues) {
      currentValues = currentValues.sortBy(value => value.get(sortColumn))
      if (sortDescending) {
        currentValues = currentValues.reverse()
      }
    }
    return currentValues
  })

  _handleStickyColChange = colKey => {
    const method = this.state.stickyColKeys.includes(colKey) ? 'delete' : 'add'
    this.setState({
      stickyColKeys: this.state.stickyColKeys[method](colKey)
    })
  }

  _handleStickyRowChange = rowKey => {
    const method = this.state.stickyRowKeys.includes(rowKey) ? 'delete' : 'add'
    this.setState({
      stickyRowKeys: this.state.stickyRowKeys[method](rowKey)
    })
  }

  handleChange = (rowKey, columnKey, newValue) => {
    // const {pendingValues} = this.state
    // this.setState({
    //   pendingValues: pendingValues.set(
    //     rowKey,
    //     pendingValues.get(rowKey, Map()).set(
    //       columnKey,
    //       newValue
    //     )
    //   )
    // })
  }

  render() {
    const  {
      schema,

      isSaving,
      isLoading,
      isLoadingNextPage,
      nextPageAvailable,
      error,

      values,

      style,
      readOnly,
      customInputs,
      validate,
      fieldOptions,
      clientSort,
      getRowKey,
      columnHeaderComponent,
      columnHeaderComponentProps,
      rowHeaderComponent,
      rowHeaderComponentProps,
      renderRowHeader,
      columnPrefs
    } = this.props
    const {
      pendingValues,
      // invalidMessages,
      // saveSuccess,
      // showAllValidationErrors,
      // errorSuppressed,
      // columns,

      sortColumn,
      sortDescending,
      // columnOrder,
      // columnSizes,
      // columnPrefs,
      stickyColKeys,
      stickyRowKeys
    } = this.state

    const isDirty = pendingValues.size > 0

    // let currentValues = values && values.mergeDeep(pendingValues)

    const currentValues = this._getKeyedMergedSortedRows(
      values,
      pendingValues,
      getRowKey,
      clientSort,
      sortColumn,
      sortDescending
    )

    const columns = schema.getDataTableColumns(columnPrefs)

    return (
      <div className="schemer_table">
        <Grid
          schema={schema}
          rows={currentValues}
          columns={columns}

          stickyRowKeys={stickyRowKeys}
          stickyColKeys={stickyColKeys}
          onStickyRowChange={this._handleStickyRowChange}
          onStickyColChange={this._handleStickyColChange}

          renderRowHeader={renderRowHeader}
          columnHeaderComponent={columnHeaderComponent}
          columnHeaderComponentProps={columnHeaderComponentProps}
          rowHeaderComponent={rowHeaderComponent}
          rowHeaderComponentProps={rowHeaderComponentProps}

          readOnly={readOnly}
          onChange={this.handleChange}
        />
        {isLoading &&
          <CircleLoader loading overlay />
        }
        {isDirty &&
          <div>CHANGED TABLE</div>
        }
      </div>
    )
  }
}